import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';

const Testimonials = () => {
  const reviews = [
    {
      name: "Alexander Wright",
      role: "CEO & Founder",
      company: "Apex Digital Solutions",
      image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&w=150&h=150&q=80",
      review: "RojrzTech completely revolutionized our digital infrastructure. Their Web Design package didn't just give us a beautiful website; it boosted our conversion rate by 40%. Absolutely top-tier development!",
      rating: 5,
    },
    {
      name: "Sarah Jenkins",
      role: "Marketing Director",
      company: "Vanguard Retail Group",
      image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&w=150&h=150&q=80",
      review: "Our experience with their SMM and Content Marketing team was flawless. They captured our brand's voice perfectly and executed high-converting social campaigns. Highly recommended for scaling brands.",
      rating: 5,
    },
    {
      name: "Marcus Thorne",
      role: "Operations Head",
      company: "Nova Fintech Corp",
      image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?auto=format&fit=crop&w=150&h=150&q=80",
      review: "The level of precision they brought during the REQ gathering and Development phase was mind-blowing. Their technical SEO optimization alone pushed our keyword rankings straight to page one on Google.",
      rating: 5,
    },
    {
      name: "Sophia Martinez",
      role: "Founder",
      company: "Bloom E-commerce",
      image: "https://images.unsplash.com/photo-1534528741775-53994a69daeb?auto=format&fit=crop&w=150&h=150&q=80",
      review: "We migrated our legacy store to React with RojrzTech, and speed improved by 200%. Our bounce rate dropped instantly. They are true partners in scaling online retail.",
      rating: 5,
    },
    {
      name: "David Chen",
      role: "Product Owner",
      company: "Zeta Healthcare",
      image: "https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?auto=format&fit=crop&w=150&h=150&q=80",
      review: "Delivered our HIPPA-compliant mobile app 3 weeks ahead of schedule. The codebase is incredibly clean, and the communication throughout was stellar.",
      rating: 5,
    },
    {
      name: "Elena Rostova",
      role: "Marketing Lead",
      company: "Horizon Real Estate",
      image: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?auto=format&fit=crop&w=150&h=150&q=80",
      review: "They didn't just build a portal; they integrated advanced analytics and automated follow-ups that quadrupled our organic lead conversion rate in under 90 days.",
      rating: 5,
    },
  ];

  return (
    <section className="w-full py-8 md:py-28 bg-transparent relative z-10 overflow-hidden border-none select-none">
      
      {/* Testimonials Swiper CSS Overrides */}
      <style>{`
        .testimonials-simple-swiper {
          padding-bottom: 50px !important;
        }
        .testimonials-simple-swiper .swiper-pagination-bullet {
          background: rgba(255, 255, 255, 0.2) !important;
          opacity: 1;
          transition: all 0.3s ease;
        }
        .testimonials-simple-swiper .swiper-pagination-bullet-active {
          background: #F3CA52 !important;
          width: 24px;
          border-radius: 4px;
        }
      `}</style>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* Section Header with Pill Subheading */}
        <div className="text-center mb-8 md:mb-20">
          <div className="inline-flex items-center gap-2 bg-[#F3CA52]/10 border border-[#F3CA52]/20 px-4 py-1.5 rounded-full mb-4">
            <span className="w-2 h-2 rounded-full bg-[#F3CA52] animate-pulse" />
            <span className="text-xs font-black text-[#F3CA52] uppercase tracking-[0.2em]">
              Client Success
            </span>
          </div>
          <p className="text-4xl sm:text-5xl font-black text-white tracking-tight mb-4">
            Hear From Our <span className="text-[#F3CA52]">Elite Partners</span>
          </p>
          <div className="w-20 h-1 bg-gradient-to-r from-transparent via-[#F3CA52] to-transparent mx-auto mt-2" />
          <p className="max-w-2xl mx-auto text-zinc-400 text-base sm:text-lg mt-4">
            Don't just take our word for it. Discover how we've empowered businesses worldwide to scale their digital frontiers.
          </p>
        </div>

        {/* Flat Swiper Slider (Simple Horizontal Layout) */}
        <Swiper
          modules={[Autoplay, Pagination]}
          spaceBetween={30}
          loop={true}
          autoplay={{
            delay: 3500,
            disableOnInteraction: false,
          }}
          pagination={{
            clickable: true,
          }}
          className="testimonials-simple-swiper"
          breakpoints={{
            0: {
              slidesPerView: 1,
            },
            768: {
              slidesPerView: 2,
            },
            1024: {
              slidesPerView: 3,
            }
          }}
        >
          {reviews.map((item, index) => (
            <SwiperSlide key={index} className="h-auto">
              <div className="group relative rounded-3xl p-8 bg-zinc-950/30 backdrop-blur-md border border-zinc-900 hover:border-zinc-700/60 transition-all duration-500 transform hover:-translate-y-2 flex flex-col justify-between h-full min-h-[350px] shadow-xl hover:shadow-[0_0_40px_rgba(243,202,82,0.04)]">
                
                {/* Giant Quote Icon */}
                <div className="absolute top-6 right-8 text-zinc-800/20 group-hover:text-[#F3CA52]/10 transition-colors duration-500 pointer-events-none">
                  <svg className="w-12 h-12 fill-currentColor" viewBox="0 0 24 24">
                    <path d="M14.017 21v-7.391c0-5.704 3.748-9.762 9-10.154v4.034c-2.894.213-4.237 1.547-4.237 4.133H24v9.378H14.017zM0 13.609c0-5.704 3.748-9.762 9-10.154v4.034c-2.894.213-4.237 1.547-4.237 4.133H9v9.378H0v-9.378z"/>
                  </svg>
                </div>

                <div>
                  {/* Gold Stars */}
                  <div className="flex items-center gap-1 mb-6">
                    {[...Array(item.rating)].map((_, i) => (
                      <svg
                        key={i}
                        className="w-4 h-4 text-[#F3CA52] drop-shadow-[0_0_4px_rgba(243,202,82,0.5)]"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                      >
                        <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                      </svg>
                    ))}
                  </div>

                  {/* Review text */}
                  <p className="text-zinc-400 text-sm sm:text-[15px] leading-relaxed italic mb-8 group-hover:text-zinc-200 transition-colors duration-300">
                    "{item.review}"
                  </p>
                </div>

                {/* Profile section */}
                <div className="flex items-center gap-4 pt-6 border-t border-zinc-900/60 mt-auto">
                  <div className="relative">
                    <img
                      src={item.image}
                      alt={item.name}
                      className="w-12 h-12 rounded-full object-cover border-2 border-zinc-800 group-hover:border-[#F3CA52] transition-colors duration-500 shadow-md"
                    />
                    <div className="absolute inset-0 rounded-full bg-gradient-to-tr from-[#F3CA52] to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 -z-10 scale-110" />
                  </div>
                  
                  <div>
                    <h4 className="text-sm font-extrabold text-white tracking-wide group-hover:text-[#F3CA52] transition-colors duration-300">
                      {item.name}
                    </h4>
                    <p className="text-xs text-zinc-500 font-medium mt-0.5">
                      {item.role}, <span className="text-zinc-400 font-semibold">{item.company}</span>
                    </p>
                  </div>
                </div>

              </div>
            </SwiperSlide>
          ))}
        </Swiper>

      </div>
    </section>
  );
};

export default Testimonials;